<script>
    export default {
        name: "Overlay",
        props: {
            closeModal: {
                type: Boolean,
                default: false
            }
        }
    }

</script>

<template>
    <Transition name="fade">
        <div v-if="closeModal" @click="closeModal = false, $emit('closeModal', closeModal)" class="overlay"></div>
    </Transition>
</template>

<style scoped>
.overlay {
       position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,.5);
    z-index: 51;
    cursor: pointer;
}

</style>